import React from "react";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import Link from "./link";
import { useMediaQuery } from "react-responsive";

const TripleInfo = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div id="tripleInfo">
      <div className="title" dangerouslySetInnerHTML={{ __html: isMobile ? content.titleMobile : content.title }} />
      <div className="gridContainer">
        {content.cards.map((element, index) => (
          <div key={index} className="gridItem">
            {element?.image?.url && <img src={element.image.url} alt="icon" />}
            {element?.title && <p className="title">{element.title}</p>}
            {element?.contentDesktop && (
              <div
                className="text"
                dangerouslySetInnerHTML={{
                  __html: isMobile ? element.contentMobile ?? element.contentDesktop : element.contentDesktop
                }}
              />
            )}
          </div>
        ))}
      </div>
      {content?.linkUrl && (
        <Link
          className="buttonLink sm"
          link={content?.linkUrl}
          text={
            <>
              <span>{content?.linkText}</span> <ArrowRight className="arrow right" />
            </>
          }
        />
      )}
    </div>
  );
};

export default TripleInfo;
